// extracted by mini-css-extract-plugin
module.exports = {"BulletPointsDescription__Container":"uYDr8a2Gy9H2d-lNkPgUCA=="};